import Splide from '@splidejs/splide';
// import '@splidejs/splide/css';
// import '@splidejs/splide/css/core';

new Splide('.banners-splide', {
    type: 'fade',
    arrows: true,
    autoplay: true,
    pagination: true,
    rewind: true,
    autoHeight: false
}).mount();
